import type { paths } from '../../types/clients/money-limits'
import { useOpenapi } from '#imports'

/**
 * @title useMoneyLimitsClient
 * @see Docs https://money-limits-prod.spilnu.dk/api/documentation
 */
export const useMoneyLimitsClient = () => {
    const client = useOpenapi<paths>({
        baseUrl: '/gateway/money-limits/api',
        service: 'moneyLimits'
    })

    return {
        client
    }
}
